module.exports = __webpack_public_path__ + "static/img/2.b333a01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market101/2.png
// module id = k2Pi
// module chunks = 1